<!-- src\views\components\MediaGallery.vue -->
<template>
    <div class="card mb-4">
        <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <h4>Select Media</h4>
        </div>

        <div class="card-body px-3 pt-2 pb-4">
            <div class="gallery-grid">
                <div v-for="media in mediaList" :key="media.id" class="media-card"
                    :class="{ 'selected': isSelected(media) }" @click="toggleSelection(media)">
                    <!-- Media Type Tag -->
                    <div class="media-tag" :class="media.type.startsWith('image') ? 'image-tag' : 'video-tag'">
                        {{ media.type.startsWith('image') ? "Image" : "Video" }}
                    </div>

                    <!-- Selected Overlay -->
                    <div class="selected-overlay" v-if="isSelected(media)">✔</div>

                    <!-- Media Preview -->
                    <!-- Note: media.url now contains your local backend address -->
                    <template v-if="media.type.startsWith('image')">
                        <img :src="media.url" class="media-preview" />
                    </template>
                    <template v-else-if="media.type.startsWith('video')">
                        <video class="media-preview" muted>
                            <source :src="media.url" :type="media.type" />
                        </video>
                    </template>
                </div>
            </div>

            <!-- Confirm Button -->
            <div class="text-center mt-3">
                <button class="btn confirm-btn" @click="confirmSelection">Confirm Selection</button>
            </div>
        </div>
    </div>
</template>

<script>
import MediaDataService from "../../services/MediaDataService.js";
export default {
    data() {
        return {
            // mediaList: [
            //     { id: 1, url: "https://storage.googleapis.com/lok-sevak/media/1740556727629-2024-03-21-65fbcd64cc50c.webp", type: "image/jpeg" },
            //     { id: 2, url: "https://storage.googleapis.com/lok-sevak/media/1740556727629-2024-03-21-65fbcd64cc50c.webp", type: "image/jpeg" },
            //     { id: 3, url: "https://storage.googleapis.com/lok-sevak/media/1740656713101-9559153-uhd_4096_2160_25fps.mp4", type: "video/mp4" },
            //     { id: 4, url: "https://storage.googleapis.com/lok-sevak/media/1740656713101-9559153-uhd_4096_2160_25fps.mp4", type: "video/mp4" },
            //     { id: 5, url: "https://storage.googleapis.com/lok-sevak/media/1740556727629-2024-03-21-65fbcd64cc50c.webp", type: "image/jpeg" },
            //     { id: 6, url: "https://storage.googleapis.com/lok-sevak/media/1740556727629-2024-03-21-65fbcd64cc50c.webp", type: "image/jpeg" },
            //     { id: 7, url: "https://storage.googleapis.com/lok-sevak/media/1740656713101-9559153-uhd_4096_2160_25fps.mp4", type: "video/mp4" },
            //     { id: 8, url: "https://storage.googleapis.com/lok-sevak/media/1740656713101-9559153-uhd_4096_2160_25fps.mp4", type: "video/mp4" },
            // ],
            formData: {
                event_name: '',
                availableUsers: '',
                availableUsersGroup: '',
                status: '',
            },
            mediaList: [],
            selectedMedia: [],
        };
    },
    mounted() {
        // Get previously selected media from URL query
        const selected = this.$route.query.selectedMedia;
        if (selected) {
            this.selectedMedia = JSON.parse(selected);
        }

        // Retrieve form data from the query and update the state
        const eventName = this.$route.query.event_name;
        const availableUsers = this.$route.query.availableUsers;
        const availableUsersGroup = this.$route.query.availableUsersGroup;
        const status = this.$route.query.status;

        // Optionally, store this data to use it in the gallery if needed (for display or confirmation)
        this.formData = {
            event_name: eventName,
            availableUsers: availableUsers,
            availableUsersGroup: availableUsersGroup,
            status: status,
        };
    },
    created() {
        this.getAllMedia();
    },
    methods: {
        isSelected(media) {
            return this.selectedMedia.some((item) => item.id === media.id);
        },
        getAllMedia() {
            MediaDataService.getAll()
                .then(response => {
                    this.mediaList = response.data.map(user => ({
                        id: user.id,
                        // This mappings works perfectly with the new local URL format
                        url: user.media_url, 
                        type: user.type == 1 ? "image/jpeg" : "video/mp4",
                    }));
                })
                .catch(e => {
                    console.log(e);
                });
        },
        toggleSelection(media) {
            const index = this.selectedMedia.findIndex((item) => item.id === media.id);
            if (index === -1) {
                this.selectedMedia.push(media);
            } else {
                this.selectedMedia.splice(index, 1);
            }
        },
        confirmSelection() {
            this.$router.push({
                path: "/add-playlist",
                query: {
                    selectedMedia: JSON.stringify(this.selectedMedia),
                    event_name: this.formData.event_name,
                    availableUsers: this.formData.availableUsers,
                    availableUsersGroup: this.formData.availableUsersGroup,
                    status: this.formData.status
                },
            });
        },
    },
};
</script>

<style scoped>
/* Grid Layout - 4 cards per row */
.gallery-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* 4 cards per row */
    gap: 15px;
    padding: 15px;
}

/* Media Card */
.media-card {
    position: relative;
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    background: #ffffff;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 2px solid transparent;
}

.media-card:hover {
    transform: scale(1.03);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.media-card.selected {
    border-color: #007bff;
    box-shadow: 0 0 12px rgba(0, 123, 255, 0.5);
}

/* Media Preview */
.media-preview {
    width: 100%;
    height: 140px;
    object-fit: cover;
    border-radius: 5px;
}

/* Selected Overlay */
.selected-overlay {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 128, 0, 0.8);
    color: white;
    font-size: 14px;
    font-weight: bold;
    padding: 5px 8px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

/* Media Type Tag */
.media-tag {
    position: absolute;
    bottom: 8px;
    left: 8px;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 5px;
    color: white;
}

.image-tag {
    background: linear-gradient(135deg, #007bff, #0056b3);
}

.video-tag {
    background: linear-gradient(135deg, #ff4500, #b22222);
}

/* Confirm Button */
.confirm-btn {
    padding: 12px 24px;
    font-size: 16px;
    background-color: #141727;
    color: white;
    border: none;
    border-radius: 5px;
    transition: background 0.3s ease-in-out;
    font-weight: bold;
}

.confirm-btn:hover {
    background-color: #007bff;
}
</style>